module.exports = __webpack_public_path__ + "img/20180414165927.0072e8f3.jpg";